import axios from 'axios';
import { useContext, useEffect, useRef, useState } from 'react'
import { NavLink, useParams } from 'react-router-dom';
import { ConfigContext } from '../../../Context/ConfigContext';
import { OverlayLoader, Spinner } from '../../../Components/Shimmers';
import { Helmet } from 'react-helmet';
import CarInfoBox from '../../Cars/CarInfoBox';
import { toast, ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share';
import { RiFacebookBoxLine, RiLinkedinBoxFill, RiMailFill, RiTwitterXFill, RiWhatsappFill } from 'react-icons/ri';
import OEPartImages from './OEPartImages';
import { AddToCartNotifier } from '../../../Components/CartComponents';
import CompatibilityCars from '../PartDetails/CompatibilityCars';
import SimilarParts from '../PartDetails/SimilarParts';
import Reviews from '../PartDetails/Reviews';
import { CartsContext } from '../../../Context/CartsContext';
import DeliveryDaysComponent from '../PartDetails/DeliveryDaysComponent';
import { AddToRecent } from '../../../Helper/RecentCart';
import GetPaymentMethods from '../PartDetails/GetPaymentMethods';
import SimilarCharacteristics from '../PartDetails/SimilarCharacteristics';
import OESimilarParts from './OESimilarParts';
import { UseRewardsPoints } from '../../../Components/GlobalFunctions';
import { axiosGet } from '../../../Apis/axiosMethods';

const OEPartDetails = () => {

  const {
    dir,
    business_type,
    apiHeaderJson,
    FavItems,
    setIsCartDropdownOpen,
    apiURL,
    business_id,
    OEImagesURL,
    business_delivery_days,
    currency
  } = useContext(ConfigContext);

  const headers = apiHeaderJson;
  const { t } = useTranslation();

  const [InvalidCarMatchWithPart, setInvalidCarMatchWithPart] = useState(localStorage.getItem('car_info') ? true : false);
  const car_info = localStorage.getItem('car_info') ? JSON.parse(localStorage.getItem('car_info')) : [];
  const [InvalidCarMatchWithPartLoading, setInvalidCarMatchWithPartLoading] = useState(true);


  const { part_slug, brand_name } = useParams();
  const { AddToCart, GetCartItemQty, AddToFavorite, RemoveToFavorite, GetStockPolicyItem } = useContext(CartsContext);
  const [selectQty, setSelectedQty] = useState(1);
  const [specLimit, setSpecLimit] = useState(10);

  const [isFavouriteUpdate, setIsFavouriteUpdate] = useState(false);


  const [oeThumb, setOEThumb] = useState(`${apiURL}/public/placeholder_category.jpeg`)

  const slugArr = part_slug.split("-");

  const ART_SEARCH_NUMBER = slugArr.pop();

  const [partInfo, setPartInfo] = useState({});
  const [loading, setLoading] = useState(true);
  const [reviewsData, setReviewsData] = useState([]);
  const [isFavorite, setIsFavorite] = useState(false);

  const [addToCartLoading, setAddToCartLoading] = useState(false);
  const isAddingRef = useRef(false);


  const GetOEPartInfo = async () => {
    try {
      setLoading(true)
      const response = await axiosGet(`/Parts/GetOEPartDetails`, {
        art_search_number: ART_SEARCH_NUMBER,
        part_number: ART_SEARCH_NUMBER,
        currency,
        business_type: business_type,
        lang: "en",
        brand_name
      })

      if (response?.data?.success) {
        setPartInfo(response?.data?.data)
        setReviewsData(response?.data?.reviews)

        const row = response?.data?.data;

        AddToRecent(
          row?.ART_ID,
          row?.ART_ARTICLE_NR,
          row?.ART_PRODUCT_NAME,
          row?.stock_brand_name,
          0,
          0,
          1,
          oeThumb,
          window.location.href,
          0,
          row?.stock_oe
        );

      }

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const [policyMinQty, setPolicyMinQty] = useState(1);

  useEffect(() => {
    const loadStockPolicy = async () => {
      if (!partInfo) return;

      const stockPolicy = await GetStockPolicyItem(
        partInfo?.ART_SEARCH_NUMBER,
        partInfo?.stock_oe,
        partInfo?.ART_SUP_ID || partInfo?.stock_sup_id,
        partInfo?.ART_SUP_BRAND || partInfo?.stock_brand_name
      );

      const minQty = Number(stockPolicy?.policy_min_qty || 1);

      setPolicyMinQty(minQty);
      setSelectedQty(minQty);
    };

    loadStockPolicy();
  }, [part_slug, brand_name, partInfo]);


  const incrementQty = async () => {
    const prev_qty = Number(await GetCartItemQty(ART_SEARCH_NUMBER));

    const stock = Number(partInfo?.stock_available_qty);
    const step = Number(policyMinQty || 1);

    const currentQty = Number(selectQty);

    const nextQty = currentQty + step;

    if (stock >= prev_qty + nextQty) {
      setSelectedQty(nextQty);
      return;
    }

    const remainingStock = stock - prev_qty;

    if (remainingStock > currentQty) {
      setSelectedQty(remainingStock);
      return;
    }

    toast.success(
      <AddToCartNotifier
        item_name={t("sorry_we_have_only", {
          value: stock,
        })}
      />
    );
  };

  const decrementQty = () => {
    const step = Number(policyMinQty || 1);
    const currentQty = Number(selectQty);
    if (currentQty % step !== 0) {
      setSelectedQty(Math.floor(currentQty / step) * step);
      return;
    }

    setSelectedQty(Math.max(step, currentQty - step));
  };

  const handleAddToCart = async (partInfo) => {
    if (isAddingRef.current) return;

    isAddingRef.current = true;
    setAddToCartLoading(true);

    try {
      const url = window.location.href;

      const prev_qty = await GetCartItemQty(partInfo?.ART_SEARCH_NUMBER);

      const addQty = Number(selectQty);

      if (Number(qty) >= addQty + prev_qty) {
        const item = {
          ART_ID: partInfo?.ART_ID,
          ART_ARTICLE_NR: partInfo?.ART_SEARCH_NUMBER,
          PRODUCT_GROUP_EN: partInfo?.ART_PRODUCT_NAME,
          stock_price_mrp: partInfo?.stock_price_mrp,
          ART_SUP_ID: 0,
          ART_SUP_BRAND: partInfo?.stock_brand_name,
          inventory_store_id: partInfo?.inventory_store_id,
          stock_oe: partInfo?.stock_oe ?? 0,
          VD_QTY: partInfo?.stock_available_qty,
          VD_BG_PRICE: partInfo?.stock_bg_price,
          VD_BB_PRICE: partInfo?.stock_bb_price
        };

        await AddToCart(
          item,
          addQty,
          oeThumb,
          url
        );

        setIsCartDropdownOpen(true);
        window.scrollTo(0, 0);

      } else {
        toast.success(
          <AddToCartNotifier
            item_name={t("sorry_we_have_only", { value: qty })}
            item_img={"https://api.carz7.com/public/placeholder_category.jpeg"}
          />,
          {}
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setAddToCartLoading(false);
      isAddingRef.current = false;
    }
  };




  const handleRemoveToFavorite = async () => {
    try {
      await RemoveToFavorite(partInfo);
      setIsFavorite(false);
    } catch (error) {
      // setLoading(false);
    }
  }

  const handleAddToFavorite = async () => {
    try {
      const partImg = `${OEImagesURL}?part_number=${partInfo?.ART_SEARCH_NUMBER.trim().replace(/[^a-zA-Z0-9]/g, '')}`
        || `${apiURL}/public/placeholder_category.jpeg`;

      const url = window.location.href;

      const data = {
        business_id,
        item_id: partInfo?.ART_ID,
        item_number: partInfo?.ART_SEARCH_NUMBER.replace(/[^a-zA-Z0-9]/g, ''),
        item_title: partInfo?.ART_PRODUCT_NAME,
        item_sup_id: 0,
        item_mrp: partInfo?.stock_price_mrp,
        item_price: Number(business_type) === 1 ? partInfo?.stock_bg_price : partInfo?.stock_bb_price,
        item_qty: 1,
        item_img_url: partImg,
        item_url: url,
        max_qty: partInfo?.stock_available_qty,
        item_store_id: partInfo?.inventory_store_id,
        item_stock_oe: partInfo?.stock_oe,
        item_delivery_days: partInfo?.stock_delivery_days,
        item_brand_name: partInfo?.stock_brand_name
      };

      await AddToFavorite(data);
      setIsFavouriteUpdate(prev => !prev);
    } catch (error) {
      console.log("Error adding to favorites:", error);
      toast.error(t("Error adding to favorites."));
    }
  };

  useEffect(() => {
    if (FavItems && partInfo) {
      const foundItem = FavItems && FavItems.find(item => item.item_number === partInfo?.ART_SEARCH_NUMBER);
      if (foundItem) {
        setIsFavorite(true);
      }
    }
  }, [FavItems, partInfo, isFavouriteUpdate])

  const invalidPartMatch = (value) => {
    setInvalidCarMatchWithPart(value);
    setInvalidCarMatchWithPartLoading(false);
  }

  useEffect(() => {
    GetOEPartInfo()
  }, [ART_SEARCH_NUMBER])

  const isBG = business_type === 1;

  const price = isBG ? Number(partInfo?.stock_bg_price || 0)
    : Number(partInfo?.stock_bb_price || 0);

  const qty = Number(partInfo?.stock_available_qty || 0);

  const hasPrice = price > 0;
  const inStock = hasPrice && qty > 0;

  const beforePrice = Number(
    business_type === 1
      ? partInfo?.stock_before_bg_price
      : partInfo?.stock_before_bb_price
  );


  const rating = partInfo?.ART_AVG_RATING ?? 0;
  const totalReviews = partInfo?.TOTAL_REVIEWS ?? 0;
  const roundedRating = Math.round(rating);

  return (

    <>
      {
        loading ?
          <div style={{ height: "70vh" }}>
            <OverlayLoader />
          </div>
          :
          <main className='main'>
            {
              partInfo &&
              <>
                <Helmet>
                  {partInfo && <title>
                    {`${partInfo && partInfo.stock_brand_name} ${partInfo && partInfo.ART_ARTICLE_NR} ${partInfo && partInfo.ART_PRODUCT_NAME}`
                      ?? part_slug}
                  </title>
                  }
                  <meta
                    name="keywords"
                    content={`${partInfo && partInfo.stock_brand_name}, 
                ${partInfo && partInfo.ART_ARTICLE_NR}, 
                ${partInfo && partInfo.ART_PRODUCT_NAME}
                 `}
                  />
                </Helmet>



                <div className="container">
                  <nav aria-label="breadcrumb" className="breadcrumb-nav">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <NavLink to={'/'}>
                          <i className="icon-home" />
                        </NavLink>
                      </li>
                      <li className="breadcrumb-item">
                        <NavLink to={`/Spare-Parts/Catelog`}>Catelog</NavLink>
                      </li>
                      {partInfo ? (
                        <li className="breadcrumb-item">
                          {partInfo.ART_PRODUCT_NAME}{" "}
                        </li>
                      ) : (
                        <li className="breadcrumb-item">
                          <NavLink to={() => { }}>...</NavLink>
                        </li>
                      )}
                    </ol>


                  </nav>

                  <CarInfoBox />

                  {/* {partInfo && InvalidCarMatchWithPartLoading === false && localStorage.getItem('car_info') && car_info && car_info[0] &&
                    <div>
                      {loading === false && InvalidCarMatchWithPart ?
                        <div className='pl-5 pr-5 pt-5 pb-3' style={{ backgroundColor: 'rgb(254, 245, 245)' }}>
                          <div style={{ color: 'rgb(226, 10, 24)' }}><i className="fas fa-times-circle"></i> {t('this_part_not_fits_your')}</div>
                          <div style={{ color: 'rgb(254, 245, 245)' }}><h3 style={{ fontWeight: 400 }}> {car_info && car_info[0] && car_info[0].TYPEL}</h3></div>
                        </div>
                        :
                        <div className='pl-5 pr-5 pt-5 pb-3' style={{ backgroundColor: 'rgb(245, 254, 247)' }}>
                          <div style={{ color: '#009e7e' }}><i className="fas fa-check-circle"></i> {t('this_part_fits_your')}</div>
                          <div style={{ color: '#009e7e' }}><h3 style={{ fontWeight: 400 }}> {car_info && car_info[0] && car_info[0].TYPEL}</h3></div>
                        </div>

                      }
                    </div>
                  } */}

                  <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />




                  <div className="product-single-container product-single-default">
                    <div className="cart-message d-none">
                      <strong className="single-cart-notice">

                      </strong>
                      <span>has been added to your cart.</span>
                    </div>
                    <div className='row'>



                      <div className='col-md-6'>
                        <h3 className="product-title mb-2 mt-2"   >
                          {partInfo && partInfo.stock_brand_name} {partInfo && partInfo.ART_ARTICLE_NR} {partInfo && partInfo.ART_PRODUCT_NAME}
                        </h3>
                      </div>

                      <div className="col-md-6 mt-2 d-flex justify-content-start align-items-center">
                        {policyMinQty > 1 && (
                          <div style={{
                            backgroundColor: '#E3F2FD',
                            padding: '8px 16px',
                            borderRadius: '6px',
                            border: '1px solid #64B5F6',
                            borderLeft: '5px solid #1976D2',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '10px',
                            maxWidth: '100%'
                          }}>
                            <i className="fas fa-info-circle" style={{ color: '#1976D2', fontSize: '18px' }}></i>
                            <span style={{
                              color: '#0D47A1',
                              fontSize: '13px',
                              fontWeight: '500',
                              whiteSpace: 'nowrap'
                            }}>
                              This product can only be ordered in multiples of <strong
                                style={{
                                  fontSize: '18px',
                                  color: '#1565C0',
                                  borderRadius: '4px'
                                }}>{policyMinQty}</strong>
                            </span>
                          </div>
                        )}
                      </div>

                      <div className='col-md-12 mt-1'>
                        <div className="ratings-container">
                          {partInfo && <span className="mt-1 ml2 mr-2">{t('article_number', { value: partInfo.ART_ARTICLE_NR })}</span>}

                          <NavLink
                            to="#"
                            className="rating-link"
                            onClick={(e) => {
                              e.preventDefault();
                              const reviewsSection = document.getElementById('reviews-section');
                              if (reviewsSection) {
                                reviewsSection.scrollIntoView({ behavior: 'smooth' });
                              }
                            }}
                          >
                            {roundedRating > 0
                              ? '★'.repeat(roundedRating) + '☆'.repeat(5 - roundedRating)
                              : '☆☆☆☆☆'
                            }

                            ({totalReviews} Reviews)
                          </NavLink>

                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-5 col-md-6 product-single-gallery">
                        {partInfo && <OEPartImages PART_NUMBER={partInfo.ART_SEARCH_NUMBER} setOEThumb={setOEThumb} />}
                      </div>

                      {/* End .product-single-gallery */}
                      <div className="col-lg-3 col-md-6 product-single-details">
                        {/* End .price-box */}
                        <div className="product-desc ml-0">
                          <div
                            className="tab-pane fade show active"
                            id="product-desc-content"
                            role="tabpanel"
                            aria-labelledby="product-tab-desc"
                          >


                            {/* <div className="product-desc-content">


                              {
                                (Array.isArray(partInfo) ? partInfo : [partInfo])
                                  .filter(Boolean)
                                  .map((part, index) => {

                                    let articleCriteria = [];

                                    try {
                                      let parsed = part?.ARTICLE_CRITERIA_JSON;

                                      while (typeof parsed === "string") {
                                        parsed = JSON.parse(parsed);
                                      }

                                      articleCriteria = Array.isArray(parsed) ? parsed : [];
                                    } catch (err) {
                                      console.log("ARTICLE_CRITERIA_JSON Parse Error:", err);
                                    }

                                    return (
                                      <div key={`info-spec-${index}`}>
                                        <h5 style={{ fontSize: "18px", lineHeight: 0 }}>
                                          {t("specification")}
                                        </h5>

                                        <table
                                          className="table"
                                          style={{
                                            fontSize: "13px",
                                            color: "#333",
                                          }}
                                        >
                                          <tbody>
                                            {articleCriteria
                                              .slice(0, specLimit)
                                              .map((criteria, indixSub) => (
                                                <tr key={`info-tr-${indixSub}`}>
                                                  <td style={{ padding: "5px" }}>
                                                    <span
                                                      style={{
                                                        color:
                                                          ["64193NLHCB", "64210NLHCB", "64211CBNHCB"].includes(
                                                            part.ART_SEARCH_NUMBER
                                                          ) &&
                                                            criteria.criteria_en?.toLowerCase() === "quantity"
                                                            ? "red"
                                                            : "#333",
                                                        fontWeight:
                                                          ["64193NLHCB", "64210NLHCB", "64211CBNHCB"].includes(
                                                            part.ART_SEARCH_NUMBER
                                                          ) &&
                                                            criteria.criteria_en?.toLowerCase() === "quantity"
                                                            ? "600"
                                                            : "400",
                                                      }}
                                                    >
                                                      {criteria.criteria_en}
                                                    </span>
                                                  </td>

                                                  <td style={{ padding: "5px" }}>
                                                    <span
                                                      style={{
                                                        color:
                                                          ["64193NLHCB", "64210NLHCB", "64211CBNHCB"].includes(
                                                            part.ART_SEARCH_NUMBER
                                                          ) &&
                                                            criteria.criteria_en?.toLowerCase() === "quantity"
                                                            ? "red"
                                                            : "#333",
                                                        fontWeight:
                                                          ["64193NLHCB", "64210NLHCB", "64211CBNHCB"].includes(
                                                            part.ART_SEARCH_NUMBER
                                                          ) &&
                                                            criteria.criteria_en?.toLowerCase() === "quantity"
                                                            ? "600"
                                                            : "400",
                                                      }}
                                                    >
                                                      {criteria.value_en}
                                                    </span>
                                                  </td>
                                                </tr>
                                              ))}
                                          </tbody>
                                        </table>

                                        {articleCriteria.length > 10 && (
                                          <center>
                                            <button
                                              onClick={() =>
                                                setSpecLimit(specLimit > 10 ? 10 : 200)
                                              }
                                              className="btn btn-link"
                                            >
                                              {specLimit > 10 ? t("Less") : t("More")}
                                            </button>
                                          </center>
                                        )}
                                      </div>
                                    );
                                  })
                              }
                            </div> */}


                            <div className="product-desc-content">
                              {(Array.isArray(partInfo) ? partInfo : [partInfo])
                                .filter(Boolean)
                                .map((part, index) => {
                                  let articleCriteria = [];

                                  try {
                                    let parsed = part?.ARTICLE_CRITERIA_JSON;

                                    while (typeof parsed === "string") {
                                      parsed = JSON.parse(parsed);
                                    }

                                    articleCriteria = Array.isArray(parsed) ? parsed : [];
                                  } catch (err) {
                                    console.log("ARTICLE_CRITERIA_JSON Parse Error:", err);
                                  }

                                  const specialParts = [
                                    "64193NLHCB",
                                    "64210NLHCB",
                                    "64211CBNHCB",
                                  ];

                                  const isSpecialPart = specialParts.includes(
                                    part?.ART_SEARCH_NUMBER
                                  );

                                  // Group criteria with the same name
                                  const groupedCriteria = [];

                                  articleCriteria.forEach((criteria) => {
                                    const criteriaName = criteria.criteria_en || "";
                                    const criteriaValue = criteria.value_en ?? "";

                                    const existing = groupedCriteria.find(
                                      (item) =>
                                        item.criteria_en.toLowerCase() ===
                                        criteriaName.toLowerCase()
                                    );

                                    if (existing) {
                                      existing.values.push(criteriaValue);
                                    } else {
                                      groupedCriteria.push({
                                        criteria_en: criteriaName,
                                        values: [criteriaValue],
                                      });
                                    }
                                  });

                                  return (
                                    <div key={`info-spec-${index}`}>
                                      <h5
                                        style={{
                                          fontSize: "18px",
                                          marginBottom: "15px",
                                        }}
                                      >
                                        {t("specification")}
                                      </h5>

                                      <table
                                        className="table"
                                        dir={dir}
                                        style={{
                                          width: "100%",
                                          tableLayout: "fixed",
                                          textAlign: dir === "rtl" ? "right" : "left",
                                          fontSize: "13px",
                                          color: "#333",
                                          borderCollapse: "collapse",
                                        }}
                                      >
                                        <tbody>
                                          {groupedCriteria
                                            .slice(0, specLimit)
                                            .map((criteria, criteriaIndex) => {
                                              const isQuantity =
                                                criteria.criteria_en.toLowerCase() ===
                                                "quantity";

                                              const shouldHighlight =
                                                isSpecialPart && isQuantity;

                                              return (
                                                <tr key={`info-tr-${index}-${criteriaIndex}`}>
                                                  <td
                                                    style={{
                                                      width: "40%",
                                                      padding: "8px 10px",
                                                      verticalAlign: "top",
                                                      borderBottom: "1px solid #ddd",
                                                      overflowWrap: "anywhere",
                                                      color: shouldHighlight ? "red" : "#333",
                                                      fontWeight: shouldHighlight ? "600" : "400",
                                                    }}
                                                  >
                                                    {criteria.criteria_en}
                                                  </td>

                                                  <td
                                                    style={{
                                                      width: "60%",
                                                      padding: "0 10px",
                                                      verticalAlign: "top",
                                                      borderBottom: "1px solid #ddd",
                                                      overflowWrap: "anywhere",
                                                    }}
                                                  >
                                                    {criteria.values.map((value, valueIndex) => (
                                                      <div
                                                        key={`value-${index}-${criteriaIndex}-${valueIndex}`}
                                                        style={{
                                                          padding: "8px 0",
                                                          borderBottom:
                                                            valueIndex < criteria.values.length - 1
                                                              ? "1px solid #ddd"
                                                              : "none",
                                                          color: shouldHighlight ? "red" : "#333",
                                                          fontWeight: shouldHighlight ? "600" : "400",
                                                        }}
                                                      >
                                                        {value || "-"}
                                                      </div>
                                                    ))}
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                        </tbody>
                                      </table>

                                      {groupedCriteria.length > 10 && (
                                        <center>
                                          <button
                                            type="button"
                                            onClick={() =>
                                              setSpecLimit(specLimit > 10 ? 10 : 200)
                                            }
                                            className="btn btn-link"
                                          >
                                            {specLimit > 10 ? t("Less") : t("More")}
                                          </button>
                                        </center>
                                      )}
                                    </div>
                                  );
                                })}
                            </div>



                            {/* End .product-desc-content */}
                          </div>
                        </div>
                        {/* End .product-desc */}
                        <ul className="single-info-list ml-2" >
                          <li className="mr-5">
                            {t('part_number')} : <strong>
                              {partInfo && partInfo.ART_ARTICLE_NR}
                            </strong>
                          </li>
                          <li>
                            {t('category')} : <strong>
                              <NavLink to={() => { }} className="product-category">
                                {partInfo && partInfo.ART_PRODUCT_NAME}
                              </NavLink>
                            </strong>
                          </li>
                          {car_info && car_info[0] && car_info[0].ART_SUP_BRAND &&
                            <li>

                              {t('brand')} : <strong>
                                <NavLink to={() => { }} className="product-category">
                                  {car_info && car_info[0] && car_info[0].ART_SUP_BRAND && car_info[0].ART_SUP_BRAND}
                                </NavLink>
                              </strong>
                              ,
                            </li>}
                          <li> {t('condition')}:{" "} <strong> <NavLink to={() => { }} className="product-category"> {t('new')} </NavLink> </strong> </li>

                        </ul>

                        {/* End .product-action */}
                        <hr className="divider mb-0 mt-0" />
                        <div className="product-single-share mb-3">
                          <label className="sr-only">{t('share')}:</label>
                          <div className="social-icons mr-2">
                            <FacebookShareButton url={window.location.href}>
                              <i className="social-icon  fab" target="_blank" title="Facebook" >
                                <RiFacebookBoxLine />
                              </i>
                            </FacebookShareButton>
                            <TwitterShareButton url={window.location.href}>
                              <i className="social-icon  fab" target="_blank" title="Twitter" >
                                <RiTwitterXFill />
                              </i>
                            </TwitterShareButton>
                            <LinkedinShareButton url={window.location.href}>
                              <i className="social-icon  fab" target="_blank" title="Linkedin" >
                                <RiLinkedinBoxFill />
                              </i>
                            </LinkedinShareButton>
                            <WhatsappShareButton url={window.location.href}>
                              <i className="social-icon  fab" target="_blank" title="WhatsApp" >
                                <RiWhatsappFill />
                              </i>
                            </WhatsappShareButton>
                            <EmailShareButton url={window.location.href}>
                              <i className="social-icon  fab" target="_blank" title="Mail" >
                                <RiMailFill />
                              </i>
                            </EmailShareButton>

                          </div>
                        </div>
                      </div>


                      <div className='col-lg-4 col-md-6'>
                        <div className="product-action">
                          <div className='row'>




                            <div className='col-md-12 mb-2'>

                              {/* IN STOCK */}
                              {inStock && (
                                <div style={{ marginBottom: '6px' }}>
                                  <span style={{ color: '#007600' }}>
                                    <i className="far fa-dot-circle"></i>
                                  </span>
                                  <span style={{ marginLeft: '6px', color: '#555' }}>
                                    {t('in_stock')} (Item(s) Left : {qty})
                                  </span>
                                </div>
                              )}

                              {/* OUT OF STOCK */}
                              {!inStock && (
                                <h1 className='mt-4'>{t('out_of_stock')}</h1>
                              )}

                              {/* PRICE */}
                              {inStock && (
                                <div style={{ display: "flex", alignItems: "center" }}>
                                  <div>
                                    <span style={{
                                      fontSize: "35px",
                                      fontWeight: 600,
                                      lineHeight: 1
                                    }}>
                                      {partInfo?.display_price}
                                    </span>
                                  </div>

                                  <div style={{ marginLeft: "10px", marginTop: "18px" }}>
                                    {Number(beforePrice) > price && (
                                      <span style={{ color: '#666', fontSize: '16px' }}>
                                        Was:&nbsp;
                                        <del style={{ fontWeight: 500 }}>
                                          {Number(beforePrice).toFixed(2)} AED
                                        </del>
                                      </span>
                                    )}
                                  </div>
                                </div>
                              )}

                              {/* OFFER */}
                              {inStock && (
                                <div>
                                  <span style={{ color: '#007600', fontWeight: 600 }}>
                                    Offer price excl. 5% VAT,
                                  </span>
                                  {
                                    (currency || "").toLowerCase() !== "usd" &&
                                    <span style={{ marginLeft: '6px', color: '#B12704', fontWeight: 600 }}>
                                      Free Delivery
                                    </span>
                                  }
                                </div>
                              )}

                            </div>


                            {
                              hasPrice && qty > 0 &&
                              <div className='col-md-12 mb-2' style={{ marginTop: "-12px" }}>
                                {
                                  partInfo &&
                                  ((partInfo?.stock_delivery_days || 0) + (business_delivery_days || 0)) > 0 && (currency || "").toLowerCase() !== "usd" && (
                                    <DeliveryDaysComponent
                                      stock_delivery_days={partInfo?.stock_delivery_days}
                                      business_delivery_days={business_delivery_days}
                                    />
                                  )
                                }
                              </div>
                            }

                            {/* ================= QTY SELECT ================= */}
                            {hasPrice && qty > 0 && (
                              <div className="col-md-4">
                                <table
                                  className='table-bordered'
                                  style={{ width: '110px' }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        rowSpan={2}
                                        style={{
                                          verticalAlign: 'middle',
                                          textAlign: 'center',
                                          fontWeight: '500',
                                          color: '#132530',
                                          height: '50px'
                                        }}
                                      >
                                        {selectQty}
                                      </td>
                                      <td
                                        style={{ padding: 0, textAlign: 'center', fontSize: '12px', cursor: 'pointer' }}
                                        onClick={() => incrementQty(partInfo)}
                                      >
                                        <i className='fas fa-chevron-up'></i>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style={{ padding: 0, textAlign: 'center', fontSize: '12px', cursor: 'pointer' }}
                                        onClick={() => decrementQty(partInfo)}
                                      >
                                        <i className='fas fa-chevron-down'></i>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            )}

                            {/* ================= ADD TO CART ================= */}
                            <div className="col-md-8">
                              {hasPrice && qty > 0 && (
                                <button
                                  onClick={() => handleAddToCart(partInfo)}
                                  className="btn btn-dark add-cart text-light"
                                  style={{ width: '100%' }}
                                  disabled={
                                    addToCartLoading ||
                                    isAddingRef.current
                                  }
                                >
                                  <i className='fas fa-shopping-cart'></i> {t('add_to_cart')}
                                </button>
                              )}
                            </div>


                            {/* ================= WISHLIST ================= */}
                            {
                              hasPrice && qty > 0 &&
                              <div
                                className="col-md-4 mt-2"
                                style={{ cursor: 'pointer' }}
                                onClick={() =>
                                  isFavorite ? handleRemoveToFavorite() : handleAddToFavorite()
                                }
                              >
                                <i
                                  className={`isFavorite ${isFavorite ? 'fas' : 'far'} fa-heart favHeart ${isFavorite ? 'active' : ''}`}
                                  style={{ fontSize: '18px' }}
                                ></i>
                                <span style={{ fontSize: '14px', fontWeight: 500, marginLeft: '6px' }}>
                                  {t('add_to_wishlist')}
                                </span>
                              </div>
                            }

                            {price > 0 && hasPrice > 0 && currency.toLowerCase() !== "usd" &&
                              (
                                <div className="alert alert-danger" style={{ border: "1px dashed #f06548" }}>
                                  <div className="d-flex align-items-center">

                                    <lord-icon
                                      src="https://cdn.lordicon.com/nkmsrxys.json"
                                      trigger="loop"
                                      style={{ width: "60px", height: "60px" }}
                                      colors="primary:#cc000b,secondary:#0e1f2a"
                                    />

                                    <div>
                                      <span style={{ color: "#000" }}>
                                        You will get
                                      </span>

                                      <span className="ml-2 mr-2">
                                        <b className='text-primary'>
                                          {UseRewardsPoints(price) ?? 0} rewards points
                                        </b>
                                      </span>

                                      <span style={{ color: "#000" }}>
                                        on this
                                      </span>
                                    </div>

                                  </div>
                                </div>
                              )}



                          </div>
                        </div>
                      </div>


                    </div>


                    {partInfo && <CompatibilityCars ART_ID={partInfo?.ART_ID} invalidPartMatch={invalidPartMatch} />}
                    {partInfo && <OESimilarParts ART_ID={partInfo?.ART_ID} part={partInfo} />}
                    {partInfo && <SimilarParts ART_ID={partInfo?.ART_ID} part={partInfo} />}


                    <hr style={{ marginTop: 0, marginBottom: '10px' }} />
                    <div id="reviews-section">
                      {partInfo &&
                        <Reviews title={t('have_you_ever_bought',
                          { value: `${partInfo?.ART_SUP_BRAND} ${partInfo?.ART_ARTICLE_NR} ${partInfo?.ART_PRODUCT_NAME} ` })}
                          partNumber={partInfo?.ART_SEARCH_NUMBER}
                          reviews={reviewsData}
                        />
                      }
                    </div>


                    {partInfo && <GetPaymentMethods part={partInfo} />}
                    {partInfo && <SimilarCharacteristics ART_ID={partInfo.ART_ID} part={partInfo} />}
                    {/* {partInfo && <RecentViews />} */}


                  </div>
                </div>
              </>
            }
          </main>
      }
    </>
  )
}

export default OEPartDetails
